<!-- @format -->

<template>
  <div class="home">
    <div class="client-container">
      <div
        class="cbg"
        :style="
          'background: url(' +
            partnerBackgroundUrl +
            ') center center; background-size: cover;'
        "
      ></div>
      <div class="cbgmenu"></div>
      <div class="ui twelve column padded grid centered">
        <notifications group="client" position="bottom center" />
        <div class="row">
          <div class="twelve wide column">
            <div>
              <h2>Users</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="twelve wide column">
            <div class="ui secondary pointing menu"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui column padded grid centered">
      <div class="row">
        <div class="twelve wide column">
          <div class="ui raised padded text segment">
            <div v-if="!showNewUserScreen">
              <div v-if="message != ''" class="ui message">{{ message }}</div>
              <table class="ui compact table">
                <thead v-if="!loading">
                  <tr>
                    <th>Email</th>

                    <th>Permissions</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody v-if="!loading">
                  <tr
                    v-if="c.displayName != 'mark@analytics.co.za'"
                    v-for="c in finalResults"
                    :key="c.id"
                  >
                    <td>
                      {{ c.displayName }}
                    </td>

                    <td>
                      <span v-for="p in c.permissions">
                        <span class="ui label">{{ p }}</span> |
                      </span>
                    </td>
                    <td>
                      <div v-if="c.permissionChanged">Save</div>
                      <div
                        v-if="user.displayName != c.displayName"
                        @click.prevent="deleteUser(c.displayName)"
                        class="ui tiny red  basic button"
                      >
                        Delete
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-if="loading">
                  <tr>
                    <td>
                      <div
                        class="hollow-dots-spinner"
                        v-if="loading"
                        :style="spinnerStyle"
                      >
                        <div class="dot"></div>
                        <div class="dot"></div>
                        <div class="dot"></div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="ui grid">
                <div class="ui four wide column">
                  <div
                    class="ui primary large button"
                    v-if="!showNewUserScreen"
                    @click="showNewUserScreen = true"
                  >
                    Create New User
                  </div>
                  <div v-if="false">
                    <div
                      class="ui  large green button"
                      v-if="!showNewUserScreen && showSaveButton"
                      @click="savePermissions"
                    >
                      Save
                    </div>
                    <div
                      class="ui  large button"
                      v-if="!showNewUserScreen && showSaveButton"
                      @click="showNewUserScreen = true"
                    >
                      Cancel
                    </div>
                  </div>
                </div>
                <div class="ui twelve wide column">
                  <sui-menu
                    v-if="totalPages > 1"
                    style="float: right"
                    pagination
                  >
                    <a is="sui-menu-item" @click.prevent="getResults(1)" icon>
                      <sui-icon name="left chevron" />First Page
                    </a>
                    <a
                      is="sui-menu-item"
                      v-if="
                        currentPageNr - 4 > 0 && currentPageNr - 4 <= totalPages
                      "
                      @click.prevent="getResults(currentPageNr - 4)"
                      >{{ currentPageNr - 4 }}</a
                    >
                    <a
                      is="sui-menu-item"
                      v-if="
                        currentPageNr - 3 > 0 && currentPageNr - 3 <= totalPages
                      "
                      @click.prevent="getResults(currentPageNr - 3)"
                      >{{ currentPageNr - 3 }}</a
                    >
                    <a
                      is="sui-menu-item"
                      v-if="
                        currentPageNr - 2 > 0 && currentPageNr - 2 <= totalPages
                      "
                      @click.prevent="getResults(currentPageNr - 2)"
                      >{{ currentPageNr - 2 }}</a
                    >
                    <a
                      is="sui-menu-item"
                      v-if="
                        currentPageNr - 1 > 0 && currentPageNr - 1 <= totalPages
                      "
                      @click.prevent="getResults(currentPageNr - 1)"
                      >{{ currentPageNr - 1 }}</a
                    >
                    <div is="sui-menu-item">
                      <strong>{{ currentPageNr }}</strong>
                    </div>

                    <a
                      is="sui-menu-item"
                      v-if="
                        currentPageNr + 1 > 0 && currentPageNr + 1 <= totalPages
                      "
                      @click.prevent="getResults(currentPageNr + 1)"
                      >{{ currentPageNr + 1 }}</a
                    >
                    <a
                      is="sui-menu-item"
                      v-if="
                        currentPageNr + 2 > 0 && currentPageNr + 2 <= totalPages
                      "
                      @click.prevent="getResults(currentPageNr + 2)"
                      >{{ currentPageNr + 2 }}</a
                    >
                    <a
                      is="sui-menu-item"
                      v-if="
                        currentPageNr + 3 > 0 && currentPageNr + 3 <= totalPages
                      "
                      @click.prevent="getResults(currentPageNr + 3)"
                      >{{ currentPageNr + 3 }}</a
                    >
                    <a
                      is="sui-menu-item"
                      v-if="
                        currentPageNr + 4 > 0 && currentPageNr + 4 <= totalPages
                      "
                      @click.prevent="getResults(currentPageNr + 4)"
                      >{{ currentPageNr + 4 }}</a
                    >

                    <a
                      is="sui-menu-item"
                      icon
                      @click.prevent="getResults(totalPages)"
                    >
                      <sui-icon name="right chevron" />Last Page
                    </a>
                  </sui-menu>
                </div>
              </div>
            </div>
            <div class="ui segment" v-show="showNewUserScreen">
              <div>
                <div class="ui attached message">
                  <div class="content">
                    <div class="header">New User</div>
                  </div>
                </div>
                <div class="ui form attached fluid segment">
                  <div class="ui field">
                    <label>First Name</label>
                    <input v-model="firstName" />
                  </div>
                  <div class="ui field">
                    <label>Last Name</label>
                    <input v-model="lastName" />
                  </div>
                  <div class="ui field">
                    <label>E-Mail</label>
                    <input v-model="email" />
                  </div>
                </div>
                <div class="ui segment message">
                  <sui-button
                    v-show="false"
                    @click.prevent="editClick"
                    type="submit"
                    class="primary"
                    >Edit</sui-button
                  >
                  <div is="sui-button-group">
                    <sui-button
                      v-if="id != 0"
                      @click.prevent="showNewUserScreen = false"
                      >Cancel</sui-button
                    >
                    <sui-button-or v-if="id != 0" />
                    <sui-button
                      :disabled="!canSave"
                      positive
                      @click.prevent="saveUser"
                      >Create</sui-button
                    >
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as _ from "lodash";
import {
  createUser,
  getUsers,
  deleteUser,
  assignRole,
  unassignAllPermissions,
} from "@/gateway";
import { ClientView } from "@/dtos";
import moment from "moment";

export default {
  name: "ProposalList",
  props: {
    msg: String,
  },
  data() {
    return {
      showSaveButton: false,
      availablePermissions: [
        { key: "createClients", text: "createClients", value: "createClients" },
        { key: "deleteClients", text: "deleteClients", value: "deleteClients" },
        { key: "manageUsers", text: "manageUsers", value: "manageUsers" },
      ],
      // new client
      message: "",
      firstName: "",
      lastName: "",
      currentAge: 55,
      email: "",
      birthday: null,
      update: false,
      showNewUserScreen: false,
      //
      results: [],
      filterStatus: "Saved",
      searchText: "",
      orderBy: "updated_as_at",
      order: "desc",
      loading: false,
      totalRecords: 0,
      currentPageNr: 1,
      currentPageSize: 5,
      totalPages: 1,
      allRecords: {
        saved: 0,

        archived: 0,
      },
    };
  },
  watch: {
    results: {
      handler: function(oldValue, newValue) {
        if (newValue) {
          console.log("old:", oldValue, "new", newValue);
          for (var i = 0; i < newValue.length; i++) {
            this.showSaveButton = true;
          }
        }
      },
      deep: true,
    },
  },
  computed: {
    user() {
      if (this.$store.state.user) return this.$store.state.user;
      else return "";
    },
    canSave() {
      if (this.firstName != "" && this.lastName != "" && this.email != "") {
        return true;
      } else return false;
    },
    finalResults() {
      var final = [];
      var rr = this.update;
      this.update != rr;
      for (var i = 0; i < this.results.length; i++) {
        var r = this.results[i];
        r.editpermissions = false;
        final.push(r);
      }
      return final;
    },
    partnerBackgroundUrl() {
      if (this.$store.state.partnerBackgroundUrl)
        return this.$store.state.partnerBackgroundUrl;
      else return "";
    },
  },
  methods: {
    editpermission(c) {
      var r = _.filter(this.finalResults, { id: c.id });
      this.update != this.update;
      r.editpermissions = true;
      c.editpermissions = true;
    },
    filter: function(arr, filtr) {
      return _.filter(arr, filtr);
    },
    permissionChanged(event) {
      event.permissionChanged = true;
      // this.showSaveButton = true;
    },
    async savePermissions() {
      for (var i = 0; i <= this.results.length - 1; i++) {
        var u = this.results[i];
        if (u.displayName != this.user.displayName) {
          console.log("unassignallpermissions", u.displayName);
          const r = await unassignAllPermissions({
            userName: u.userName,
          });

          for (var p = 0; p <= u.permissions.length - 1; p++) {
            console.log("assign permission", u.displayName, u.permissions[p]);
            const response = await assignRole({
              permission: u.permissions[p],
              userName: u.userName,
            });
          }
        }
      }
    },
    async deleteUser(email) {
      this.message = "";
      const response = await deleteUser({ email: email });
      if (response) {
        this.$notify({
          group: "client",
          title: "User deleted",
          position: "bottom right",
          type: "success",
        });

        this.message = "";
        this.getResults(1);
      }
    },
    calculateAge(arg) {
      return moment().diff(moment(arg, "YYYY-MM-DD"), "years");
    },
    formatDate(arg, fmt) {
      if (fmt) return moment(arg, "YYYY-MM-DD").format(fmt);
      else return moment(arg, "YYYY-MM-DD").format("DD MMM YYYY HH:mm");
    },
    friendlyDate(arg, fmt) {
      if (fmt) return moment(arg, "YYYYMMDD").format(fmt);
      else return moment(arg, "YYYYMMDD").format("DD MMM YYYY HH:mm");
    },
    async saveUser() {
      this.message = "";
      var response = await createUser({
	      appName: this.$store.state.appName,
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
      });
      if (response) {
        this.$notify({
          group: "client",
          title: "User created",
          position: "bottom right",
          type: "success",
        });
        this.firstName = "";
        this.lastName = "";
        this.email = "";
        this.showNewUserScreen = false;
        this.init();
      }
    },
    async refreshResults(orderBy, ord) {
      this.pageNr = 1;
      this.orderBy = orderBy;
      this.order = ord;
      this.getResults(1);
    },
    async getResults(pageNr, filterStatus) {
      if (filterStatus) this.filterStatus = filterStatus;
      this.loading = true;
      //  await new Promise(r => setTimeout(r, 2000));
      var response = await getUsers();

      this.results = response.result;
      this.loading = false;
    },
    async getResultCount(filterStatus) {
      var response = await getUsers({
        pageSize: 100000,
        pageNr: 1,
      });
      //   console.log(response.totalRecords);

      /* if (filterStatus == "Saved")
        this.allRecords.saved = response.totalRecords;

      if (filterStatus == "Archived")
        this.allRecords.archived = response.totalRecords;
        */
      //    console.log(this.allRecords);
    },
    async archivePlan(id) {
      //  console.log(" archiving plan " + id);
      /* const response = await updatePlanStatus({ id: id, status: "Archived" });
      console.log(response);
      if ((response.success = 1)) {
        await this.getResults(1);
        await this.getResultCount("Saved");
        await this.getResultCount("Archived");
      }*/
    },
    async movePlanToSaved(id) {
      /* const response = await updatePlanStatus({ id: id, status: "Saved" });
      if ((response.success = 1)) {
        await this.getResults(1);
        await this.getResultCount("Saved");
        await this.getResultCount("Archived");
      }*/
    },
    async init() {
      this.allRecords.saved = 0;
      this.allRecords.archived = 0;
      await this.getResults(1);
    },
  },
  async mounted() {
    this.init();
    this.birthday = moment()
      .add(-45, "years")
      .format("YYYY-MM-DD");
  },
};
</script>
